import React from 'react';
import ClinicAssociationsTable from './ClinicAssociationsTable';

function EditPartnerModal({
  partnerInfo,
  edit,
  data,
  setData,
  allClinics
}) {

  const [ selectedClinic, setSelectedClinic ] = React.useState(null);
  const [ foundClinic, setFoundClinic ] = React.useState({});


  const clinicOptions = React.useMemo(() => [], [data]);

  React.useEffect(() => {
    setSelectedClinic(null);
    setFoundClinic({});
    clinicOptions.length = 0;
    if (allClinics.length) {
      allClinics.forEach(clinic => {
        if (data.find(({ _id }) => _id === clinic._id)) {
          return;
        } else {
          return clinicOptions.push({
            label: clinic.name,
            value: clinic._id
          })
        }
      })
    }
  
  }, [edit, data])

  const columns = [
    {
      Header: 'Name',
      accessor: 'name',
    },
    {
      Header: 'Type',
      accessor: 'type',
    },
    {
      Header: 'City',
      accessor: 'city',
    },
  ];




  if (!partnerInfo) return '';

  
    return (
      <div className='flex flex-col w-full'>
        <ClinicAssociationsTable 
          columns={columns} 
          data={data} 
          setData={setData} 
          clinicOptions={clinicOptions} 
          selectedClinic={selectedClinic} 
          setSelectedClinic={setSelectedClinic}
          allClinics={allClinics}
          foundClinic={foundClinic}
          setFoundClinic={setFoundClinic}
          edit={edit}
        />

      </div>
  )
}

export default EditPartnerModal
